module.exports = __webpack_public_path__ + "img/next-purchase.220feed5.png";